import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::replay
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:631
* @route '/admin/whatsapp-instances/{instance}/dlq/{entryId}/replay'
*/
export const replay = (args: { instance: string | { id: string }, entryId: string | number } | [instance: string | { id: string }, entryId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

replay.definition = {
    methods: ["post"],
    url: '/admin/whatsapp-instances/{instance}/dlq/{entryId}/replay',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::replay
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:631
* @route '/admin/whatsapp-instances/{instance}/dlq/{entryId}/replay'
*/
replay.url = (args: { instance: string | { id: string }, entryId: string | number } | [instance: string | { id: string }, entryId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            instance: args[0],
            entryId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
        entryId: args.entryId,
    }

    return replay.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace('{entryId}', parsedArgs.entryId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::replay
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:631
* @route '/admin/whatsapp-instances/{instance}/dlq/{entryId}/replay'
*/
replay.post = (args: { instance: string | { id: string }, entryId: string | number } | [instance: string | { id: string }, entryId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::replay
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:631
* @route '/admin/whatsapp-instances/{instance}/dlq/{entryId}/replay'
*/
const replayForm = (args: { instance: string | { id: string }, entryId: string | number } | [instance: string | { id: string }, entryId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::replay
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:631
* @route '/admin/whatsapp-instances/{instance}/dlq/{entryId}/replay'
*/
replayForm.post = (args: { instance: string | { id: string }, entryId: string | number } | [instance: string | { id: string }, entryId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

replay.form = replayForm

const dlq = {
    replay: Object.assign(replay, replay),
}

export default dlq